import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../components/Sidebar";
import axios from "axios";

export default function ProductsList() {
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [search, setSearch] = useState("");
  const [sort, setSort] = useState("asc");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    axios.get("https://api.livestockify.com/api/admin/products").then((res) => {
      setProducts(res.data);
    });
  }, []);

  const handleDelete = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const openDeleteModal = (id) => {
    setDeleteId(id);
    setShowDeleteModal(true);
  };

  const confirmDelete = async () => {
    try {
      await axios.delete(
        `https://api.livestockify.com/api/admin/products/${deleteId}`,
      );

      setProducts((prev) => prev.filter((p) => p.id !== deleteId));
      setShowDeleteModal(false);
      setDeleteId(null);
    } catch (error) {
      console.error("Delete failed:", error);
    }
  };

  const filteredProducts = products
    .filter((p) => p.name.toLowerCase().includes(search.toLowerCase()))
    .sort((a, b) =>
      sort === "asc"
        ? a.name.localeCompare(b.name)
        : b.name.localeCompare(a.name),
    );

  return (
    <div className="flex min-h-screen bg-gray-100">
      <Sidebar />

      <div className="flex-1 p-6 bg-white rounded-l-2xl">
        {/* Top Tabs */}

        <div className="flex justify-center gap-10 mb-6">
          <button
            onClick={() => navigate("/category")}
            className="text-gray-700 font-medium"
          >
            Category
          </button>

          <span className="text-green-700 font-semibold underline">
            Products
          </span>
        </div>

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-6">
          <h2 className="font-semibold text-lg">Product</h2>
          <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 w-full sm:w-auto">
            {/* SEARCH */}
            <div className="relative">
              <input
                placeholder="Search"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="border rounded-md px-4 py-2 pl-10 text-sm w-full sm:w-64"
              />
              {/* <span className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400">
        🔍
      </span> */}
            </div>

            {/* SORT */}
            <div className="flex items-center gap-2 w-full sm:w-auto">
              <span className="text-sm font-medium">Sort By</span>
              <select
                value={sort}
                onChange={(e) => setSort(e.target.value)}
                className="border rounded-md px-3 py-2 text-sm"
              >
                <option value="asc">Name (A–Z)</option>
                <option value="desc">Name (Z–A)</option>
              </select>
            </div>

            {/* ADD USER */}
            <button
              onClick={() => navigate("/add-product")}
              className="border rounded-md px-4 py-2 text-sm font-medium flex items-center justify-center gap-1 w-full sm:w-auto"
            >
              + Add Product
            </button>
          </div>
        </div>

        {/* Products Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
          {filteredProducts.map((item) => (
          

            <div
              key={item.id}
              className="relative rounded-xl overflow-hidden shadow-sm bg-white"
            >
              {/* IMAGE */}
              <img
                src={item.imageUrl}
                alt={item.name}
                className="w-full h-40  object-cover bg-gray-50"
              />

              {/* BOTTOM BLUR SECTION */}
              <div className="absolute bottom-0 left-0 right-0 bg-white/70 backdrop-blur-ms p-2">
                <div className="text-sm text-left font-semibold text-green-700">
                  {item.name}
                </div>

                <div className="text-xs text-left text-gray-600">{item.category}</div>

                <div className="flex justify-end gap-4 mt-2  text-sm font-medium">
                  <button
                    onClick={() => navigate(`/edit-product/${item.id}`)}
                    className="text-green-600 hover:underline"
                  >
                    Edit
                  </button>

                  <button
                    onClick={() => handleDelete(item.id)}
                    className="text-red-600 hover:underline"
                  >
                    Delete
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {showDeleteModal && (
        <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
          <div className="bg-white rounded-xl p-6 w-[90%] max-w-sm">
            <h3 className="font-semibold text-lg mb-3">Confirm Deletion</h3>
            <p className="text-sm text-gray-600 mb-5">
              Are you sure you want to proceed with this deletion?
            </p>

            <div className="flex justify-end gap-3">
              <button
                onClick={() => setShowDeleteModal(false)}
                className="px-4 py-1 border rounded-md text-sm"
              >
                Cancel
              </button>

              <button
                onClick={confirmDelete}
                className="px-4 py-1 bg-red-600 text-white rounded-md text-sm"
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
